import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "commaSplit"
})
export class CommaSplitPipe implements PipeTransform {
  COMMA: string = ",";
  transform(val: string, params: string[]): string[] {
    return val.split(this.COMMA);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/common/commaSplit.pipe.ts